import { useState } from 'react';

import { useAsyncStatus, useOnMount } from '..';
import { get } from '../../redux/api';
import type { FailedFetchResponse } from '../../helpers/errors';
import type { StripeInvoice } from '../../../typings/stripe';
import type { AsyncStatus } from '../../types';

type UseInvoiceHistoryReturn = {
  status: AsyncStatus;
  invoices: StripeInvoice[];
};

/**
 * This hook will retrieve the invoice history for an organization and provide Redux-like status updates for the
 * network call.
 * @returns {UseInvoiceHistoryReturn} return - The status and eventually results of the API call.
 */
const useInvoiceHistory = (): UseInvoiceHistoryReturn => {
  const { onPending, onSuccess, onError, status } = useAsyncStatus();
  const [invoices, setInvoices] = useState<StripeInvoice[]>([]);

  useOnMount(async () => {
    onPending();
    try {
      const { data } = await get<StripeInvoice[]>('/api/organization/invoices');
      setInvoices(data ?? []);
      onSuccess();
    } catch (err) {
      onError(err as FailedFetchResponse);
    }
  });

  return {
    status,
    invoices,
  };
};

export default useInvoiceHistory;
